import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormArray, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { AlertService } from '../../../../common/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { Global } from 'src/app/Global';
import { AuditTrailComponent } from 'src/app/out-of-application/audit-trail/audit-trail.component';
import { LocationService } from 'src/app/shared/location.service';
import { AppTokenHandler, HTTPStatus } from 'src/app/common/app-token-handler';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { DropdownModule } from 'primeng/dropdown';
import { MatCardModule } from '@angular/material/card';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {  ActivationStart, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-location-master',
  templateUrl: './location-master.component.html',
  styleUrls: ['./location-master.component.css'],
  // standalone:true,
  // imports: [DropdownModule,MatCardModule,AutoCompleteModule,
  //   ReactiveFormsModule,CommonModule,
  //   MatFormFieldModule,MatInputModule,NoopAnimationsModule]
})
export class LocationMasterComponent implements OnInit {

  /********************************Properties Declaration***********************************/
  LocationCreationForm: UntypedFormGroup;
  SecondaryHeadForm: UntypedFormArray;
  locationList: any;
  employeeList: any;
  filterList: any;
  private alertService: AlertService;
  IsSecondaryZoneVisible = false;
  LocationID: string;
  btnValue: string;
  IsSecondaryOwner: boolean;
  UserDetails: any;
  @ViewChild(RouterOutlet) outlet: RouterOutlet;

  /***********************************End***************************************************/
  constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService,
    private _locationService: LocationService, injector: Injector, private _dialog: MatDialog,
    public _global: Global, private appToken: AppTokenHandler,
    private status: HTTPStatus,
  ) { this.alertService = injector.get(AlertService); }

  ngOnInit() {
    /*****************************GetData By QueryString*************************/
    debugger;
    this.UserDetails = this.appToken.getLoginUserInfo();
   
    this.LocationID = this._activeRoute.snapshot.paramMap.get('ID');
    /**************************************End**********************************/

    this.LocationCreationForm = this._fb.group({
      RequestEntityId: [''],
      RequisitionDate: [new Date()],
      LocationID: ['', [Validators.required]],
      ZoneName: [''],
      ZoneHead: [''],
      IsActive: [true, [Validators.required]],
      SecondaryZoneHead: [],
      SecondaryHeadForm: this._fb.array([]),
      SecondaryZoneHeadName: [],
      SecondaryZoneHeadGPN: [],
      SecondaryZoneHeadEmail: [],
      SecondaryZoneHeadCUG: []
    });

    this.IsSecondaryOwner = false;
    this.LocationMasterList();

    if (this.LocationID != null) {
     
      this.btnValue = 'Update';
      this._global.IsAuditVisible = true;
      this.LocationCreationForm.controls.RequestEntityId.setValue(this.LocationID);
      this.GetLocationMasterDataByID(this.LocationID);
      this._global.auditTrailId = this.LocationID;
      this._global.auditTrailClass = 'LocationMaster';
    } else {
      this.btnValue = 'Submit';
      this._global.IsAuditVisible = false;
      this._global.auditTrailId = this._global.auditTrailClass = '';
    }
  }
  /****************************Section: Methods****************************/
  LocationMasterList() {
    this._commonService.BindDropDown('location').subscribe(result => {
      this.locationList = result;
    });
  }

  addItem() {
    this.SecondaryHeadForm = this.LocationCreationForm.get('SecondaryHeadForm') as UntypedFormArray;
    
    let isDuplicate: boolean;
    if (this.SecondaryHeadForm.controls.length > 0) {
      for (let index = 0; index < this.SecondaryHeadForm.controls.length; index++) {
        if (this.SecondaryHeadForm.controls[index].value.SecondaryHeadGPN ===
          this.LocationCreationForm.controls.SecondaryZoneHeadGPN.value) {
          isDuplicate = true;
        }
      }
      if (isDuplicate) {
        this.alertService.notify('warn', 'warn!', 'This  location Spoc name is already exists.');
        this.LocationCreationForm.controls.SecondaryZoneHead.reset();
        this._global.SecondaryHeadBtnVisible = false;
      } else {
        if(this.LocationCreationForm.controls.SecondaryZoneHeadEmail.value !==null && this.LocationCreationForm.controls.SecondaryZoneHeadGPN.value!==null){
          this.SecondaryHeadForm.push(
            this._fb.group({
              SecondaryHeadID: [0],
              MasterName: ['LocationMaster'],
              MasterID: [0],
              SecondaryHeadName: this.LocationCreationForm.controls.SecondaryZoneHeadName.value,
              SecondaryHeadGPN: this.LocationCreationForm.controls.SecondaryZoneHeadGPN.value,
              SecondaryHeadEmail: this.LocationCreationForm.controls.SecondaryZoneHeadEmail.value,
              SecondaryHeadCUG: this.LocationCreationForm.controls.SecondaryZoneHeadCUG.value,
              IsActive: [true]
            })
          )
        };
        this.LocationCreationForm.controls.SecondaryZoneHead.reset();
        this._global.SecondaryHeadBtnVisible = false;
      }
    } else {
      if(this.LocationCreationForm.controls.SecondaryZoneHeadEmail.value !==null && this.LocationCreationForm.controls.SecondaryZoneHeadGPN.value!==null){
      this.SecondaryHeadForm.push(
        this._fb.group({
          SecondaryHeadID: [0],
          MasterName: ['LocationMaster'],
          MasterID: [],
          SecondaryHeadName: this.LocationCreationForm.controls.SecondaryZoneHeadName.value,
          SecondaryHeadGPN: this.LocationCreationForm.controls.SecondaryZoneHeadGPN.value,
          SecondaryHeadEmail: this.LocationCreationForm.controls.SecondaryZoneHeadEmail.value,
          SecondaryHeadCUG: this.LocationCreationForm.controls.SecondaryZoneHeadCUG.value,
          IsActive: [true]
        })
      )};
      this.LocationCreationForm.controls.SecondaryZoneHead.reset();
      this._global.SecondaryHeadBtnVisible = false;
    }
  }

  SearchActiveEmployee = (event) => {
    this.status.setHttpStatus(true);
    this._commonService.Autocomplete('FillCommonData/GetActiveEmployeeRecovery', event.query).subscribe(result => {
      this.employeeList = this.filterDataList(event.query, result);
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {
      this.status.setHttpStatus(false);
    });
  }

  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }

  clearAutoComplete(controlName) {
    if (controlName === 'SecondaryZoneHead') {
      this.LocationCreationForm.controls.SecondaryZoneHeadName.reset();
      this.LocationCreationForm.controls.SecondaryZoneHeadGPN.reset();
      this.LocationCreationForm.controls.SecondaryZoneHeadCUG.reset();
      this.LocationCreationForm.controls.SecondaryZoneHeadEmail.reset();
    }
    if (controlName === 'LocationHead') {
      this.LocationCreationForm.controls.LocationHeadGPN.reset();
      this.LocationCreationForm.controls.CUG.reset();
      this.LocationCreationForm.controls.Email.reset();
      this.LocationCreationForm.controls.MobileNumber.reset();
    }
  }

  SetEmployeeDetails(event) {
    if (event.EmployeeGPN === this.LocationCreationForm.controls.SecondaryZoneHeadGPN.value) {
      alert('Primary location head can not be same as Secondary.');
      this.LocationCreationForm.controls.LocationHead.reset();
    } else {
      this.LocationCreationForm.patchValue({
        LocationHeadGPN: event.EmployeeGPN,
        CUG: event.EmpCUG,
        Email: event.EmpEmail,
        MobileNumber: event.EmpMobile,
        LocationHeadName: event.EmpName
      });
    }
  }

  SetSecondaryEmployeeDetails(event) {
    this.LocationCreationForm.patchValue({
      SecondaryZoneHeadName: event.EmpName,
      SecondaryZoneHeadGPN: event.EmployeeGPN,
      SecondaryZoneHeadCUG: event.EmpCUG,
      SecondaryZoneHeadEmail: event.EmpEmail
    });
    this._global.SecondaryHeadBtnVisible = true;
  }

  SaveLocation() {
    if (!this.LocationCreationForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();
      return false;
    }
    if(this.SecondaryHeadForm.length==0){
      alert('Please add location spoc name');
      this.showErrorsOnInvalidForm();
      return false;
    }
    
    this.status.setHttpStatus(true);
    this.LocationCreationForm.value.SecondaryHeadForm = this.SecondaryHeadForm.value;
    this._locationService.AddLocationMaster(this.LocationCreationForm.value).subscribe(data => {
      if (data.RequestIsSuccess) {
        if (data.RequestEntityId !== null) {
          alert(data.RequestMessage);
          //this.alertService.notify('success', 'Success!', data.RequestMessage);
          this._router.navigate(['admin/view-location']);          
        }
      } else {
        alert(data.RequestMessage);
       // this.alertService.notify('warn', 'warn!', data.RequestMessage);
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  LoadLocationMasterdataByID(){   
    if(this.LocationCreationForm.controls.LocationID.value!==null && this.LocationCreationForm.controls.LocationID.value!=='')
    {
      this.LocationCreationForm.controls.SecondaryHeadForm =this._fb.array([]) ;          
     this.GetLocationMasterDataByLocationID(this.LocationCreationForm.controls.LocationID.value);
    }
  }


  GetLocationMasterDataByID(LocationID: string) {
    this.status.setHttpStatus(true);   
    this._locationService.GetLocationMasterDataByID(LocationID).subscribe(data => {   
      if(data !== null)    
      {                  
        this.LocationCreationForm.patchValue(data);     
        this.LocationCreationForm.controls.IsActive.setValue(String(data.IsActive));
        this.LocationCreationForm.controls.LocationID.setValue(String(data.LocationID));     
        this.IsSecondaryZoneVisible = true;         
        this.SecondaryHeadForm = this.LocationCreationForm.get('SecondaryHeadForm') as UntypedFormArray;       
        data.SecondaryHeadForm.forEach(x => {
          this.SecondaryHeadForm.push(
            this._fb.group({
              SecondaryHeadID: x.SecondaryHeadID,
              MasterName: x.MasterName,
              MasterID: x.MasterID,
              SecondaryHeadName: x.SecondaryHeadName,
              SecondaryHeadGPN: x.SecondaryHeadGPN,
              SecondaryHeadEmail: x.SecondaryHeadEmail,
              SecondaryHeadCUG: x.SecondaryHeadCUG,
              IsActive: x.IsActive,
            }));
          if (this.UserDetails.EmpGPN === x.SecondaryHeadGPN) {
            this.IsSecondaryOwner = true;
          }
        });
      }      
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {
      this.clearAutoComplete('SecondaryZoneHead');
      this.status.setHttpStatus(false);
    });
  }

  GetLocationMasterDataByLocationID(LocationID: string) {
    this.status.setHttpStatus(true);
   
    this._locationService.GetLocationMasterDataByLocationID(LocationID).subscribe(data => { 
      
      if(data !== null)    
      {                 
        this.IsSecondaryZoneVisible = true;               
        this.SecondaryHeadForm = this.LocationCreationForm.get('SecondaryHeadForm') as UntypedFormArray;     
        data.SecondaryHeadForm.forEach(x => {
          this.SecondaryHeadForm.push(
            this._fb.group({
              SecondaryHeadID: x.SecondaryHeadID,
              MasterName: x.MasterName,
              MasterID: x.MasterID,
              SecondaryHeadName: x.SecondaryHeadName,
              SecondaryHeadGPN: x.SecondaryHeadGPN,
              SecondaryHeadEmail: x.SecondaryHeadEmail,
              SecondaryHeadCUG: x.SecondaryHeadCUG,
              IsActive: x.IsActive,
            }));
          if (this.UserDetails.EmpGPN === x.SecondaryHeadGPN) {
            this.IsSecondaryOwner = true;
          }
        });
      }      
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {
      this.clearAutoComplete('SecondaryZoneHead');
      this.status.setHttpStatus(false);
    });
  }

  removeItem(control, index) {
    
    if (this.btnValue === 'Submit') {
      const formArr = <UntypedFormArray>this.LocationCreationForm.controls.SecondaryHeadForm;
      formArr.at(index).patchValue({ IsActive: false });     
      formArr.removeAt(index);
      alert('You need to submit for effectively change.');
      
    } else {
      const formArr = <UntypedFormArray>this.LocationCreationForm.controls.SecondaryHeadForm;
      formArr.at(index).patchValue({ IsActive: false });
      alert('You need to update for effectively change.');
    }
  }
  /**********************************Method Section End****************************************/

  openAuditTrailDialog() {
    this._dialog.open(AuditTrailComponent,
      {
        width: '1000px',
        disableClose: true
      });
  }
  /****************************Error and Validation Section***********************************/
  GetFormControls(controlName) {
    return this.LocationCreationForm.controls[controlName];
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.LocationCreationForm.controls).forEach(field => {
      const control = this.LocationCreationForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  /**********************************Error Section End***************************************/
}
